import { blocks } from '@yola/ws-sdk';
import analytics from 'src/js/modules/analytics';
import textDecorationAttributes from '../constants/text-decoration-attributes';
import getParentBlockByElement from '../../../../blocks/helpers/get-parent-block-by-element';

const {
  segment: {
    constants: { events },
    trackers: { trackEvent },
  },
} = analytics;

const trackTextDecorationSettingsDialogSubmitted = ({
  targetElement,
  initialAttributesValues,
  currentAttributesValues,
  premiumAvailable,
  textDecorationPresetSelected,
}) => {
  const blockElement = getParentBlockByElement(targetElement);
  const blockId = blocks.accessors.getBlockIdByElement(blockElement);

  const isEqualAttributeValues = (attr) =>
    initialAttributesValues[attr] === currentAttributesValues[attr];

  trackEvent(events.TEXT_DECORATION_SETTINGS_DIALOG_SUBMITTED, {
    blockId,
    premiumAvailable,
    textDecorationPresetSelected,
    colorChanged: !isEqualAttributeValues(textDecorationAttributes.COLOR),
    thinkessChanged: !isEqualAttributeValues(textDecorationAttributes.THICKNESS),
    borderRadiusChanged: !isEqualAttributeValues(textDecorationAttributes.BORDER_RADIUS),
    paddingVerticalChanged: !isEqualAttributeValues(textDecorationAttributes.PADDING_VERTICAL),
    paddingHorizontalChanged: !isEqualAttributeValues(textDecorationAttributes.PADDING_HORIZONTAL),
  });
};

export default trackTextDecorationSettingsDialogSubmitted;
